import React from 'react';
import PropTypes from 'prop-types';

const FullName = props => <span>{props.data.full_name}</span>;

FullName.propTypes = {
	data: PropTypes.object.isRequired,
};

export default FullName;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/full-name.js